(function(){
  var drawer = document.getElementById('cart-drawer');
  if(!drawer) return;

  var body       = document.getElementById('cart-drawer-body');
  var subtotalEl = document.getElementById('cart-drawer-subtotal');
  var lastFocus  = null;

  /* Literal characters throughout rather than \u escapes: this file is served
     as UTF-8 and the escapes were once doubled by a tooling round-trip, which
     printed the escape itself into the page. */
  function money(cents){
    return '₹' + (cents/100).toLocaleString('en-IN', {minimumFractionDigits:2, maximumFractionDigits:2});
  }

  /* ---- Scroll lock without layout shift ----
     Hiding body overflow removes the desktop scrollbar, which reflows the
     whole page sideways. Compensate with matching padding. */
  function lockScroll(){
    var sw = window.innerWidth - document.documentElement.clientWidth;
    if(sw > 0){ document.body.style.paddingRight = sw + 'px'; }
    document.body.classList.add('cart-drawer-locked');
  }
  function unlockScroll(){
    document.body.classList.remove('cart-drawer-locked');
    document.body.style.paddingRight = '';
  }

  function openDrawer(){
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden','false');
    lockScroll();
    var close = drawer.querySelector('.cart-drawer-close');
    if(close) close.focus();
  }

  function closeDrawer(){
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden','true');
    unlockScroll();
    if(lastFocus && lastFocus.focus) lastFocus.focus();
    lastFocus = null;
  }

  function isOpen(){ return drawer.classList.contains('is-open'); }

  /* ---- Bag badge ----
     The count rides on the corner of the bag icon in the header. Three things
     happen here beyond writing the number:

       - an empty bag hides its badge, rather than displaying a nought
       - the icon's accessible name carries the count, so a screen reader
         announces "Bag, 2 items" instead of reading a stray digit
       - the badge bumps when the number goes UP, which is the only
         confirmation an add gets if the drawer is dismissed quickly

     Guarded on the element existing: the drawer markup ships on every page,
     the header badge does not have to. */
  var lastCount = null;

  function updateBagCount(count){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = count;
      el.classList.toggle('is-zero', !count);
      if(lastCount !== null && count > lastCount){
        el.classList.remove('is-bump');
        void el.offsetWidth;          /* restart the animation */
        el.classList.add('is-bump');
      }
    });

    document.querySelectorAll('[data-cart-label]').forEach(function(el){
      el.setAttribute('aria-label',
        count ? 'Open bag, ' + count + (count === 1 ? ' item' : ' items') : 'Open bag, empty');
    });

    lastCount = count;
  }

  /* Sync once on load so the label is right before anything is added. */
  updateBagCount(parseInt((document.querySelector('[data-cart-count]') || {}).textContent, 10) || 0);

  /* ---- Which button the bag shows ----  (added 2026-09-09)

     Women's stock has landed, men's has not:

         at least one women's frame in the bag  ->  Checkout
         no women's frame                       ->  free pre-registration

     A MIXED bag checks out and says so in the note, rather than blocking a
     sale that is genuinely available.

     This has to run against the LIVE bag, not the Liquid one — the drawer is
     rendered once at page load and refilled by script, so cart.items in the
     snippet is stale the moment anything is added. /cart.js carries no tags,
     only product_id, so the women's ids are written into the footer's
     data-women-ids by cart-drawer.liquid and matched here.

     Fails SAFE: an id it does not recognise counts as not-women's, so an
     unclassified product falls through to pre-registration rather than
     taking money for something that might not ship.

     THE SHIP NOTE IS WRITTEN HERE, NOT IN THE LIQUID. (2026-09-18)
     Whatever cart-drawer.liquid puts in [data-ship-note] is overwritten by
     the strings below on every render. v98 changed the Liquid to "In stock
     now." and the live bag kept saying "Dispatched by 16 September" for two
     days after that date had passed, directly above the Checkout button.
     If the wording changes, change it HERE. And never a fixed date: nothing
     updates it, so it is right for a few days and wrong forever after. */
  var womenIds = null;

  /* MEN'S LIVE AS PRE-ORDERS (28 Sep 2026). data-women-ids now lists EVERY
     frame that can be paid for (women's and men's) — see cart-drawer.liquid —
     so womenSet() reads as "sellable". menSet() is only the men's frames,
     used for the ship note: women's ship today, men's by 10 November, and a
     mixed bag goes as two parcels on one payment (Dev's choice). */
  function womenSet(footer){
    if(womenIds) return womenIds;
    womenIds = {};
    (footer.getAttribute('data-women-ids') || '').split(/\s+/).forEach(function(id){
      if(id) womenIds[id] = true;
    });
    return womenIds;
  }

  var menIds = null;
  function menSet(footer){
    if(menIds) return menIds;
    menIds = {};
    (footer.getAttribute('data-men-ids') || '').split(/\s+/).forEach(function(id){
      if(id) menIds[id] = true;
    });
    return menIds;
  }

  function paintFooter(cart){
    var footer = drawer.querySelector('[data-cart-footer]');
    if(!footer) return;

    var pay = footer.querySelector('[data-buy-state="pay"]');
    var pre = footer.querySelector('[data-buy-state="prereg"]');
    if(!pay || !pre) return;

    var items = cart.items || [];

    /* Nothing in the bag: offer neither. A buy button over an empty bag is
       just a dead end. */
    if(!items.length){
      pay.hidden = true;
      pre.hidden = true;
      return;
    }

    var set = womenSet(footer);
    var hasWomen = false, hasLater = false;
    items.forEach(function(i){
      if(set[String(i.product_id)]) hasWomen = true;
      else hasLater = true;
    });

    pay.hidden = !hasWomen;
    pre.hidden = hasWomen;

    var note = footer.querySelector('[data-ship-note]');
    if(note && hasWomen){
      var men = menSet(footer), nMen = 0, nNow = 0;
      items.forEach(function(i){
        if(!set[String(i.product_id)]) return;
        if(men[String(i.product_id)]) nMen += i.quantity; else nNow += i.quantity;
      });
      note.textContent = (nMen && nNow)
        ? 'Two parcels, one payment: your women’s frame ships today, the men’s frame by 10 November.'
        : nMen
          ? 'Pre-order — dispatched by 10 November.'
          : 'In stock — dispatched same day.';
    }
  }

  function imgUrl(url){
    if(!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  function esc(s){
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  function renderCart(cart){
    if(!body) return;
    if(!cart.items.length){
      /* Empty message is set in theme settings and carried on the container,
         so the editor controls it without touching this file. */
      var emptyText = body.getAttribute('data-empty-text') || 'Your bag is empty.';
      body.innerHTML = '<p class="cart-drawer-empty">'+esc(emptyText)+'</p>';
    } else {
      body.innerHTML = cart.items.map(function(item, idx){
        var img = item.image
          ? '<img src="'+esc(imgUrl(item.image))+'" alt="'+esc(item.product_title)+'" width="64" height="64">'
          : '';
        /* The 2nd-frame price variant carries "/ 2nd frame" or "/ Standard"
           in its title; the customer sees the colour only. */
        var vtitle = String(item.variant_title || '').replace(/\s*\/\s*(2nd frame|Standard)\s*$/i, '');
        var variant = (vtitle && vtitle !== 'Default Title')
          ? '<div class="cart-drawer-line-variant">'+esc(vtitle)+'</div>'
          : '';

        /* A discounted line (the second-frame offer, when it is a Shopify
           discount) shows what it costs now over what it was, and carries
           the discount's own title as a small tag. Any Shopify discount
           lands here the same way; the drawer does not care which. */
        /* A 2nd-frame line is not a discount in Shopify's eyes — its price is
           simply lower — so the "was" figure comes from the standard price
           in the map. */
        var second = isSecondVariant(item.variant_id);
        var wasLine = second ? secondStdPrice(item.variant_id) * item.quantity : item.original_line_price;
        var off = wasLine > item.final_line_price;
        var offTitle = second ? '2nd frame 10% off' : discountTitle(item);
        var price = off
          ? '<div>'+money(item.final_line_price)+'</div><div class="cart-drawer-line-was">'+money(wasLine)+'</div>'
          : money(item.final_line_price);
        var tag = off
          ? '<div class="cart-drawer-line-tag">'+esc(offTitle || 'Discount')+'</div>'
          : '';

        return '<div class="cart-drawer-line" data-line="'+(idx+1)+'">' + img +
          '<div class="cart-drawer-line-info">' +
            '<div class="cart-drawer-line-title">'+esc(item.product_title)+'</div>' + variant + tag +
            '<div class="cart-drawer-line-qty">' +
              '<button type="button" class="qty-btn" data-qty-decrease aria-label="Decrease quantity">−</button>' +
              '<span>'+item.quantity+'</span>' +
              '<button type="button" class="qty-btn" data-qty-increase aria-label="Increase quantity">+</button>' +
              '<button type="button" class="cart-drawer-remove" data-qty-remove>Remove</button>' +
            '</div>' +
          '</div>' +
          '<div class="cart-drawer-line-price">'+price+'</div></div>';
      }).join('');
      paintNudge(cart);
    }
    if(subtotalEl) subtotalEl.textContent = money(cart.total_price);
    paintSummary(cart);
    updateBagCount(cart.item_count);
    paintFooter(cart);
    syncSecondFramePrice(cart);
  }

  /* ---- Second frame: 10% off by PRICE, not by coupon ----  (v110, 26 Sep 2026)

     Dev's rule: two ₹999 frames = ₹999 + ₹899.10 = ₹1,898.10 in the bag, then
     Fastrr's FIRST100 15% off that → ₹1,613.39, with NO extra coupon showing
     in Fastrr. What was learned getting there (all tested on 26 Sep):
       - a Shopify AUTOMATIC discount: shown here, ignored by Fastrr;
       - a Shopify CODE: Fastrr reads it from the discount_code cookie, shows
         it as a coupon, and — taking one coupon only — drops FIRST100.
     So the 10% is a price. Each women's frame has a hidden second variant,
     option2 "2nd frame", 10% cheaper (#second-frame-map, written by
     cart-drawer.liquid). This function keeps the bag honest on every render:

       2+ women's frames  -> exactly ONE unit, the cheapest mapped frame, sits
                             on its 2nd-frame variant; everything else standard
       fewer than 2       -> nothing on a 2nd-frame variant (also catches a
                             2nd-frame variant added on its own via a link)

     One /cart/update.js call with {updates:{variantId:qty}} makes the change;
     the result is rendered straight away. Loop guard: one attempt per bag
     state. Off when the theme setting is off, and dormant until the map has
     at least one frame in it.

     It also clears anything left behind by the retired 2NDFRAME10 code (on
     the cart or in the cookie), which would otherwise take a second 10%. */
  var secMap = null, revMap = null;

  function loadSecondMap(){
    if(secMap) return;
    secMap = {}; revMap = {};
    try{
      var el = document.getElementById('second-frame-map');
      if(el) secMap = JSON.parse(el.textContent) || {};
    }catch(e){ secMap = {}; }
    Object.keys(secMap).forEach(function(std){ revMap[String(secMap[std].s)] = std; });
  }
  function hasSecondMap(){ loadSecondMap(); return Object.keys(secMap).length > 0; }
  function isSecondVariant(id){ loadSecondMap(); return !!revMap[String(id)]; }
  function secondStdPrice(id){ loadSecondMap(); var std = revMap[String(id)]; return std ? secMap[std].p : 0; }

  function offerMode(){
    var footer = drawer.querySelector('[data-cart-footer]');
    return footer ? (footer.getAttribute('data-second-frame') || 'off') : 'off';
  }

  var legacyCleaned = false;
  function cleanLegacyCode(cart){
    if(/(?:^|; )discount_code=2NDFRAME/i.test(document.cookie)){
      document.cookie = 'discount_code=; path=/; max-age=0';
    }
    var has = (cart.discount_codes || []).some(function(d){ return /^2NDFRAME/i.test(String(d.code)); });
    if(!has || legacyCleaned) return false;
    legacyCleaned = true;
    fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({discount: ''})
    }).then(function(r){ return r.json(); }).then(function(c){ if(c && c.items) renderCart(c); }).catch(function(){});
    return true;
  }

  var swapKey = '';

  function syncSecondFramePrice(cart){
    if(cleanLegacyCode(cart)) return;
    if(!hasSecondMap()) return;
    var footer = drawer.querySelector('[data-cart-footer]');
    if(!footer) return;
    var on = offerMode() !== 'off';
    var set = womenSet(footer);

    var have = {}, units = [], women = 0, sig = [];
    (cart.items || []).forEach(function(i){
      var id = String(i.variant_id);
      sig.push(id + 'x' + i.quantity);
      if(!set[String(i.product_id)]) return;
      women += i.quantity;
      var std = revMap[id] || (secMap[id] ? id : null);
      if(!std) return;                       /* a frame with no 2nd-frame variant */
      have[id] = (have[id] || 0) + i.quantity;
      for(var q = 0; q < i.quantity; q++) units.push({std: std, sec: !!revMap[id]});
    });

    var want = {};
    units.forEach(function(u){ want[u.std] = (want[u.std] || 0) + 1; });
    if(on && women >= 2 && units.length){
      /* Cheapest frame gets the 10%. On a tie, the frame already on its
         2nd-frame price keeps it — otherwise two ₹999 frames would trade the
         discount back and forth on every render. */
      var cheap = units.slice().sort(function(a, b){
        return (secMap[a.std].p - secMap[b.std].p) || ((b.sec ? 1 : 0) - (a.sec ? 1 : 0));
      })[0].std;
      want[cheap] -= 1;
      want[String(secMap[cheap].s)] = 1;
    }

    var updates = {}, changed = false;
    var ids = {};
    Object.keys(have).forEach(function(k){ ids[k] = 1; });
    Object.keys(want).forEach(function(k){ ids[k] = 1; });
    Object.keys(ids).forEach(function(id){
      var a = have[id] || 0, b = want[id] || 0;
      if(a !== b){ updates[id] = b; changed = true; }
    });
    if(!changed) return;

    var key = JSON.stringify(updates) + '|' + sig.join(',');
    if(key === swapKey) return;
    swapKey = key;

    fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({updates: updates})
    })
      .then(function(r){ return r.json(); })
      .then(function(c){
        if(!c || !c.items) return;
        renderCart(c);
        /* The /cart page is server-rendered: reload it so its lines match. */
        if(/^\/cart\/?$/.test(location.pathname)) location.reload();
      })
      .catch(function(){});
  }

  /* ---- Product page guard for the hidden 2nd-frame variant ----
     The product page picks its variant server-side. Normally that is the
     standard one (it is first), but a ?variant= link to the 2nd-frame
     variant, or the standard one selling out, would put the cheaper variant
     on the page. This puts the standard variant back in the form, shows its
     price, and marks it sold out if it is. The "Offer" radio group that
     Shopify would render for the second option is hidden by CSS below. */
  function guardProductPage(){
    if(!hasSecondMap()) return;
    var form = document.querySelector('.product-info form[action*="/cart/add"]');
    if(!form) return;
    var inp = form.querySelector('[data-variant-id]');
    if(!inp) return;
    var std = revMap[String(inp.value)];
    if(!std) return;
    var e = secMap[std];
    inp.value = std;
    var pe = document.querySelector('.product-info [data-price]');
    if(pe) pe.textContent = money(e.p);
    var sp = document.querySelector('[data-sticky-price]');
    if(sp) sp.textContent = money(e.p);
    if(!e.a){
      document.querySelectorAll('[data-add-btn], [data-sticky-add]').forEach(function(b){
        b.disabled = true; b.textContent = 'Sold out';
      });
    }
  }
  try{
    var sfStyle = document.createElement('style');
    sfStyle.textContent = '.option-group:has(input[name="option2"][value="2nd frame"]){display:none !important}' +
      /* The swipe button in the unlock band (v114). Kept here rather than in
         cart-drawer.css so the whole change is one file. Filled, so the two
         buttons read as two different routes, not the same one twice. */
      '.nudge-cta.nudge-cta--swipe{margin-top:8px;gap:7px;background:var(--ink,#14100D);color:var(--paper,#FBF9F6)}' +
      '.nudge-cta.nudge-cta--swipe:hover{background:var(--accent,#A9522A);border-color:var(--accent,#A9522A)}' +
      '.nudge-cta--swipe svg{width:14px;height:14px;fill:#E86F5A}';
    document.head.appendChild(sfStyle);
  }catch(e){}
  guardProductPage();
  (function(){
    var box = document.querySelector('.product-info');
    if(!box || !box.parentNode || !window.MutationObserver) return;
    var t = null;
    new MutationObserver(function(){
      clearTimeout(t); t = setTimeout(guardProductPage, 60);
    }).observe(box.parentNode, {childList: true, subtree: true});
  })();

  /* ---- Second-frame offer: "add one more, 10% off that frame" ----  (v109, 2026-09-26)

     Drawn under the items on every render, from the LIVE bag. Three states:

       no women's frame          -> nothing (men's are pre-orders, not charged)
       one women's frame         -> the unlock band: "1 of 2 frames", a bar
                                    half full, the promise, a button to the
                                    women's collection, three quick picks
       two or more women's       -> the applied line

     The applied line depends on WHERE the 10% lives, which the footer's
     data-second-frame says (a theme setting, see cart-drawer.liquid):

       shopify -> the discount is a Shopify automatic discount, so /cart.js
                  reports it and the line can state the rupees saved. If the
                  bag holds two frames and reports NO discount, nothing is
                  drawn: better silence than a claim the total contradicts.
       fastrr  -> the discount lives in Fastrr, invisible from here, so the
                  line says it comes off on the payment page — the wording the
                  15% block already uses for the same situation.
       off     -> nothing, in every state. The default until the discount
                  exists somewhere.

     Quantity counts: two of the same frame is two frames. That matches how a
     buy-one-get-one discount in Shopify counts them, so the band and the
     discount agree.

     The wording lives here, not in the Liquid, for the reason the ship note
     does — the body is rebuilt on every change. */
  var picks = null, picksMen = null;

  function pickList(menOnly){
    if(menOnly){
      if(picksMen) return picksMen;
      picksMen = [];
      try{
        var m = document.getElementById('cart-picks-men');
        if(m) picksMen = JSON.parse(m.textContent) || [];
      }catch(e){ picksMen = []; }
      return picksMen;
    }
    if(picks) return picks;
    picks = [];
    try{
      var el = document.getElementById('cart-picks');
      if(el) picks = JSON.parse(el.textContent) || [];
    }catch(e){ picks = []; }
    return picks;
  }

  function discountTitle(item){
    var a = item && item.line_level_discount_allocations;
    if(a && a.length && a[0].discount_application && a[0].discount_application.title){
      var t = a[0].discount_application.title;
      /* A discount CODE reports the code itself as its title ("2NDFRAME10").
         Customers should read what it does, not a string that looks like a
         coupon they were supposed to have. */
      if(/^2NDFRAME/i.test(t)) return '2nd frame 10% off';
      return t;
    }
    return '';
  }

  function paintNudge(cart){
    var footer = drawer.querySelector('[data-cart-footer]');
    if(!footer || !body) return;
    var mode = footer.getAttribute('data-second-frame') || 'off';
    if(mode === 'off') return;
    /* Nothing to promise until at least one frame has its 2nd-frame price. */
    if(mode === 'shopify' && !hasSecondMap()) return;

    var set = womenSet(footer), menS = menSet(footer);
    var women = 0, inBag = {}, anyWomen = false;
    (cart.items || []).forEach(function(i){
      if(set[String(i.product_id)]){
        women += i.quantity; inBag[i.product_id] = true;
        if(!menS[String(i.product_id)]) anyWomen = true;
      }
    });
    if(!women) return;
    /* A bag of men's frames only gets men's picks and a link to Men's. */
    var menOnly = !anyWomen;

    var el = document.createElement('div');

    if(women >= 2){
      var saved = 0;
      (cart.items || []).forEach(function(i){
        if(isSecondVariant(i.variant_id)) saved += secondStdPrice(i.variant_id) * i.quantity - i.final_line_price;
      });
      var check = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
      if(mode === 'shopify' && saved > 0){
        el.className = 'cart-drawer-nudge is-done';
        el.innerHTML = check + '<div>Second-frame offer applied — you save ' + money(saved) + '</div>';
      }else if(mode === 'fastrr'){
        el.className = 'cart-drawer-nudge is-done';
        el.innerHTML = check + '<div>Second frame 10% off — it comes off on the payment page.</div>';
      }else{
        return;
      }
      body.appendChild(el);
      return;
    }

    el.className = 'cart-drawer-nudge';
    el.innerHTML =
      '<div class="nudge-top"><span>1 of 2 frames</span><span>10% off at 2</span></div>' +
      '<div class="nudge-bar"><i></i></div>' +
      '<div class="nudge-head">Add one more frame and it’s 10% off.</div>' +
      '<div class="nudge-sub">Any frame counts, women’s or men’s. Still free delivery.</div>' +
      '<a class="nudge-cta" href="' + (menOnly ? '/collections/men' : '/collections/women') + '">Pick a second frame →</a>' +
      /* v114 (29 Sep, Dev): a second way to find the second frame — the swipe
         page, opened straight on the right deck for this bag. */
      '<a class="nudge-cta nudge-cta--swipe" href="/pages/swipe?for=' + (menOnly ? 'men' : 'women') + '">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3s-7.6-4.6-9.1-9.4C1.8 7.4 4 4.2 7.3 4.2c2 0 3.6 1.1 4.7 2.7 1.1-1.6 2.7-2.7 4.7-2.7 3.3 0 5.5 3.2 4.4 6.7-1.5 4.8-9.1 9.4-9.1 9.4z"/></svg>' +
        'Swipe to get your favourites' +
      '</a>';
    body.appendChild(el);

    /* Three quick picks that are not already in the bag. */
    var shown = pickList(menOnly).filter(function(p){ return !inBag[p.id]; }).slice(0, 3);
    if(shown.length){
      var row = document.createElement('div');
      row.className = 'nudge-picks';
      row.innerHTML =
        shown.map(function(p){
          return '<a href="'+esc(p.url)+'" aria-label="'+esc(p.name)+'"><img src="'+esc(p.img)+'" alt="" width="44" height="44" loading="lazy"></a>';
        }).join('') +
        '<span>Try ' + shown.map(function(p){ return esc(p.name); }).join(', ') + '</span>';
      body.appendChild(row);
    }
  }

  /* The discount summary above Subtotal: what the frames were, what came
     off, under the discount's own title. Hidden unless the live bag carries
     a discount. */
  function paintSummary(cart){
    var sum = drawer.querySelector('[data-cart-sum]');
    if(!sum) return;
    var saved = cart.total_discount || 0;
    if(!saved){ sum.hidden = true; return; }
    var title = '';
    (cart.items || []).some(function(i){ title = discountTitle(i); return !!title; });
    var o = sum.querySelector('[data-sum-original]');
    var d = sum.querySelector('[data-sum-discount]');
    var t = sum.querySelector('[data-sum-title]');
    if(o) o.textContent = money(cart.original_total_price || (cart.total_price + saved));
    if(d) d.textContent = '−' + money(saved);
    if(t) t.textContent = title || 'Discount';
    sum.hidden = false;
  }

  function fetchCart(){ return fetch('/cart.js', {credentials:'same-origin'}).then(function(r){ return r.json(); }); }

  /* Check the bag once per page load, so a quantity changed on the /cart page
     or a bag carried over from an earlier visit is corrected before Fastrr
     sees it. Cheap: one /cart.js read, and a write only if something is off. */
  if(hasSecondMap() || /(?:^|; )discount_code=2NDFRAME/i.test(document.cookie)){
    fetchCart().then(function(c){ if(c && c.items && c.items.length) syncSecondFramePrice(c); }).catch(function(){});
  }

  function changeLine(line, quantity){
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({line: line, quantity: quantity})
    }).then(function(r){ return r.json(); }).then(renderCart);
  }

  /* ---- All clicks handled by delegation on document ----
     Binding at load meant any re-render (or a script running before the
     markup existed) left dead buttons. */
  document.addEventListener('click', function(e){
    var opener = e.target.closest('[data-cart-drawer-open]');
    if(opener){
      e.preventDefault();
      fetchCart().then(function(cart){ renderCart(cart); openDrawer(); });
      return;
    }

    if(e.target.closest('[data-cart-drawer-close]')){
      e.preventDefault();
      closeDrawer();
      return;
    }

    var lineEl = e.target.closest('[data-line]');
    if(!lineEl || !drawer.contains(lineEl)) return;
    var line  = parseInt(lineEl.getAttribute('data-line'), 10);
    var qtyEl = lineEl.querySelector('.cart-drawer-line-qty span');
    if(!qtyEl) return;
    var qty = parseInt(qtyEl.textContent, 10);

    if(e.target.closest('[data-qty-increase]'))      changeLine(line, qty + 1);
    else if(e.target.closest('[data-qty-decrease]')) changeLine(line, Math.max(0, qty - 1));
    else if(e.target.closest('[data-qty-remove]'))   changeLine(line, 0);
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && isOpen()) closeDrawer();
  });

  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();

    var submitBtn = form.querySelector('button[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : '';
    if(submitBtn){ submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {'Accept': 'application/json'},
      body: new FormData(form)
    })
      .then(function(r){ if(!r.ok) throw new Error('add failed'); return fetchCart(); })
      .then(function(cart){ renderCart(cart); openDrawer(); })
      .catch(function(){ form.submit(); })
      .finally(function(){
        if(submitBtn){ submitBtn.disabled = false; submitBtn.textContent = originalText; }
      });
  });

  /* ---- Swipe to close ----
     Listeners are passive, so a vertical drag still scrolls the item list
     normally — the axis is decided on the first few pixels of movement and
     never taken back. */
  var panel = drawer.querySelector('.cart-drawer-panel');
  if(panel && 'ontouchstart' in window){
    var startX = 0, startY = 0, dx = 0;
    var dragging = false, decided = false, horizontal = false;

    function resetPanel(){
      panel.style.transition = '';
      panel.style.transform  = '';
    }

    panel.addEventListener('touchstart', function(e){
      if(!isOpen() || e.touches.length !== 1) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dx = 0; dragging = true; decided = false; horizontal = false;
    }, {passive:true});

    panel.addEventListener('touchmove', function(e){
      if(!dragging || e.touches.length !== 1) return;
      var x = e.touches[0].clientX - startX;
      var y = e.touches[0].clientY - startY;

      if(!decided){
        if(Math.abs(x) < 8 && Math.abs(y) < 8) return;
        decided = true;
        horizontal = Math.abs(x) > Math.abs(y) * 1.2;
        if(!horizontal){ dragging = false; return; }
        panel.style.transition = 'none';
      }

      dx = Math.max(0, x);
      panel.style.transform = 'translateX(' + dx + 'px)';
    }, {passive:true});

    function endDrag(){
      if(!dragging) return;
      dragging = false;
      var threshold = Math.min(110, panel.offsetWidth * 0.3);
      var shouldClose = horizontal && dx > threshold;
      resetPanel();
      if(shouldClose) closeDrawer();
    }

    panel.addEventListener('touchend', endDrag);
    panel.addEventListener('touchcancel', endDrag);
  }
})();
